/**
 * Query string builder for the Bundle Search API.
 */
export default class BundleRequestQueryFilterBuilder {
  archivedStatus?: BundleArchivedFilterOptions = undefined

  /**
   * Filter by archived status.
   * @param archived
   * @returns
   */
  withArchivedStatus(
    archivedStatus: BundleArchivedFilterOptions,
  ): BundleRequestQueryFilterBuilder {
    if (archivedStatus === undefined) {
      return this
    }
    this.archivedStatus = archivedStatus
    return this
  }

  /**
   * Builds the query string.
   *
   * @returns
   */
  build(): string {
    const queryParts = []

    if (this.archivedStatus !== undefined) {
      queryParts.push(`archived=${this.archivedStatus}`)
    }

    return queryParts.join(' AND ')
  }
}

export const enum BundleArchivedFilterOptions {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
